import React from 'react';
import { Package, AlertTriangle } from 'lucide-react';

export const AlertsSection = ({ stockAlerts, navigate }) => {
  return (
    <div className="lg:grid lg:grid-cols-2 lg:gap-4 space-y-4 lg:space-y-0">
      {/* Stock Alert */}
      <div className="ios-card animate-fade-in" data-testid="low-stock-alert">
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-2.5">
            <div className="w-8 h-8 rounded-full bg-red-100 flex items-center justify-center shrink-0">
              <Package size={16} className="text-red-500" />
            </div>
            <h2 className="text-sm font-semibold text-gray-900">Stok Uyarısı</h2>
          </div>
          {stockAlerts.low_stock.length > 0 && (
            <span className="text-xs font-bold text-white bg-red-500 rounded-full px-2 py-0.5 min-w-[24px] text-center">{stockAlerts.low_stock.length}</span>
          )}
        </div>
        {stockAlerts.low_stock.length > 0 ? (
          <div className="space-y-1.5">
            {stockAlerts.low_stock.slice(0, 5).map(p => (
              <div key={p.id} className="flex items-center justify-between px-3 py-2.5 bg-[#F2F2F7] rounded-xl">
                <span className="text-sm text-gray-900 font-medium">{p.name}</span>
                <span className="text-xs font-bold text-red-600">{p.current_stock} / {p.min_stock}</span>
              </div>
            ))}
            {stockAlerts.low_stock.length > 5 && (
              <button onClick={() => navigate('/stock')} className="text-xs text-[#6b6de3] font-medium mt-1">
                +{stockAlerts.low_stock.length - 5} ürün daha
              </button>
            )}
          </div>
        ) : (
          <div className="text-center py-3">
            <p className="text-[#34C759] text-sm font-medium">Tüm stoklar yeterli</p>
          </div>
        )}
      </div>

      {/* Expiry Date Alert */}
      <div className="ios-card animate-fade-in" data-testid="expiring-alert">
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-2.5">
            <div className="w-8 h-8 rounded-full bg-amber-100 flex items-center justify-center shrink-0">
              <AlertTriangle size={16} className="text-amber-500" />
            </div>
            <h2 className="text-sm font-semibold text-gray-900">SKT Uyarısı</h2>
          </div>
          {stockAlerts.expiring.length > 0 && (
            <span className="text-xs font-bold text-white bg-amber-500 rounded-full px-2 py-0.5 min-w-[24px] text-center">{stockAlerts.expiring.length}</span>
          )}
        </div>
        {stockAlerts.expiring.length > 0 ? (
          <div className="space-y-1.5">
            {stockAlerts.expiring.slice(0, 5).map(p => (
              <div key={p.id} className="flex items-center justify-between px-3 py-2.5 bg-[#F2F2F7] rounded-xl">
                <span className="text-sm text-gray-900 font-medium">{p.name}</span>
                <span className={`text-xs font-bold ${p.expired ? 'text-red-600' : 'text-amber-600'}`}>
                  {p.expired ? 'Süresi doldu' : `${p.days_left} gün kaldı`}
                </span>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-3">
            <p className="text-[#34C759] text-sm font-medium">SKT uyarısı yok</p>
          </div>
        )}
      </div>
    </div>
  );
};
